import { Target, Eye, Heart, Award } from 'lucide-react';

const values = [
  {
    icon: Target,
    title: 'Misión',
    description: 'Digitalizar y modernizar la contratación de servicios agropecuarios en Argentina, conectando productores y prestadores de manera eficiente, segura y transparente.'
  },
  {
    icon: Eye,
    title: 'Visión',
    description: 'Ser la plataforma líder de servicios rurales en Latinoamérica, transformando la manera en que el campo accede a maquinaria, tecnología y servicios profesionales.'
  },
  {
    icon: Heart,
    title: 'Valores',
    description: 'Transparencia, confianza, innovación y compromiso con el desarrollo del sector agropecuario argentino.'
  }
];

const stats = [
  { value: '2023', label: 'Año de fundación' },
  { value: 'Buenos Aires', label: 'Sede central' },
  { value: '25+', label: 'Profesionales' },
  { value: '15+', label: 'Provincias cubiertas' }
];

export const AboutSection = () => {
  return (
    <section
      id="nosotros"
      className="py-16 md:py-24 bg-[#FBF5EA]"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-10">
          <span className="inline-block text-sm font-bold uppercase tracking-[0.2em] text-[#AB6D4C] mb-3">
            Sobre Nosotros
          </span>
          <h2 className="text-3xl md:text-4xl font-medium tracking-tight text-[#051914] mb-4">
            Conocé a Prestagro
          </h2>
          <p className="text-base md:text-lg leading-relaxed text-[#051914]/70 max-w-3xl mx-auto">
            Somos un equipo apasionado por la tecnología y el campo argentino, 
            comprometidos con modernizar el sector agropecuario.
          </p>
        </div>

        {/* Two Column Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center mb-12">
          {/* Image */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden bg-[#EBE9BD]">
              <img
                src="https://customer-assets.emergentagent.com/job_prestagro-agro/artifacts/8xo04e38_darla-hueske-fqoq39Jj5us-unsplash.jpg"
                alt="Cosechadora trabajando en campo de trigo dorado"
                className="w-full h-[350px] object-cover"
              />
            </div>
            {/* Stats Card */}
            <div className="absolute -bottom-6 -right-6 bg-[#051914] text-[#FBF5EA] p-5 rounded-2xl shadow-xl hidden md:block">
              <div className="flex items-center gap-3 mb-1">
                <Award size={24} className="text-[#A9CB68]" />
                <span className="text-base font-medium">Startup destacada</span>
              </div>
              <p className="text-xs text-[#FBF5EA]/70">
                Reconocidos por innovación AgTech 2024
              </p>
            </div>
          </div>

          {/* Content */}
          <div>
            <h3 className="text-xl md:text-2xl font-medium text-[#051914] mb-4">
              Nuestra historia
            </h3>
            <p className="text-sm md:text-base leading-relaxed text-[#051914]/70 mb-4">
              Prestagro nació de la necesidad real del campo argentino. Nuestros fundadores, 
              con experiencia directa en el sector agropecuario, identificaron los problemas 
              que enfrentan diariamente productores y prestadores de servicios: demoras, 
              informalidad y falta de confianza.
            </p>
            <p className="text-sm md:text-base leading-relaxed text-[#051914]/70 mb-6">
              Desarrollamos una plataforma tecnológica que resuelve estos desafíos, 
              facilitando la conexión, contratación y pago de servicios agropecuarios 
              de manera simple, segura y transparente.
            </p>

            {/* Values */}
            <div className="space-y-3">
              {values.map((value, index) => (
                <div 
                  key={index}
                  className="flex items-start gap-3 p-3 bg-[#EBE9BD]/50 rounded-xl hover:bg-[#EBE9BD] transition-colors"
                  data-testid={`value-item-${index}`}
                >
                  <div className="w-9 h-9 bg-[#A9CB68] rounded-lg flex items-center justify-center flex-shrink-0">
                    <value.icon size={18} className="text-[#051914]" />
                  </div>
                  <div>
                    <h4 className="font-medium text-sm text-[#051914] mb-0.5">{value.title}</h4>
                    <p className="text-xs text-[#051914]/60">{value.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Stats Bar */}
        <div className="bg-[#051914] rounded-2xl p-6 md:p-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            {stats.map((stat, index) => (
              <div key={index} data-testid={`stat-item-${index}`}>
                <span className="block text-2xl md:text-3xl font-semibold text-[#A9CB68] mb-1">
                  {stat.value}
                </span>
                <span className="text-xs text-[#FBF5EA]/60">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
